
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_16mm3_sy4bn_93",
  "disabled": "awsui_disabled_16mm3_sy4bn_110",
  "expandable-header": "awsui_expandable-header_16mm3_sy4bn_114",
  "rolled-down": "awsui_rolled-down_16mm3_sy4bn_125",
  "highlighted": "awsui_highlighted_16mm3_sy4bn_128",
  "is-focused": "awsui_is-focused_16mm3_sy4bn_146",
  "variant-navigation": "awsui_variant-navigation_16mm3_sy4bn_150",
  "category": "awsui_category_16mm3_sy4bn_161",
  "expandable": "awsui_expandable_16mm3_sy4bn_114",
  "expand-icon": "awsui_expand-icon_16mm3_sy4bn_183",
  "expand-icon-up": "awsui_expand-icon-up_16mm3_sy4bn_190",
  "expand-icon-right": "awsui_expand-icon-right_16mm3_sy4bn_193",
  "items-list-container": "awsui_items-list-container_16mm3_sy4bn_207"
};
  